import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.js";
import { isLegacyGovernanceMode } from "../../lib/auth-mode.js";

/**
 * Platform admin UI (`/admin/*`) or break-glass API key (lists all tenants).
 */
export function RequirePlatformAdmin() {
  const { user } = useAuth();
  const legacy = isLegacyGovernanceMode();

  if (user?.role === "platform_admin" || legacy) {
    return <Outlet />;
  }

  return <Navigate to="/" replace />;
}
